<template>
   <div class="relative mt-8 ml-2 mr-2">
      <h1 class="text-2xl md:text-3xl uppercase font-medium mb-2 text-pilke-primary">Kiitos</h1>
      <p class="text-gray-900">Olemme vastaanottaneet Tietoja lapsesta-hakemuksen. Kiitos yhteydenotostanne.</p>
   </div>
</template>

<script>
export default {
   name: 'thankyou',

   props: ['store'],

   data () {
      return {
         storeState: this.store.state
      }
   }
}
</script>

<style scoped>
</style>
